import { useTranslation } from 'react-i18next';
import Select from '@lib/components/Select/Select';
import { FieldItem } from '@lib/interfaces/form';
import { GetLoadOptions } from '@lib/components/Select/types';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import { getOptionValidation } from '@lib/utils/validationUtils';
import { MonitoringEntity } from 'routes/Dashboard/Monitoring/enums';

export const DASHBOARD_MONITORING_ADD_FILTER_BY_ENTITY_FORM_EMPTY_VALUES = {
  [MonitoringFilterFieldNames.SiteToAdd]: undefined,
};

export default function useFilterFields({
  getSitesLoadOptions,
  getSectorsLoadOptions,
  monitoringEntity,
}: {
  getSitesLoadOptions: GetLoadOptions;
  getSectorsLoadOptions: GetLoadOptions;
  monitoringEntity: MonitoringEntity;
}): FieldItem[] {
  const { t } = useTranslation();
  const selectProps = {
    defaultOptions: false,
    isAsync: true,
    maxMenuHeight: 200,
    usePortal: true,
  };
  if (monitoringEntity === MonitoringEntity.Site) {
    return [
      {
        name: MonitoringFilterFieldNames.SiteToAdd,
        label: t('choose-site-to-add'),
        element: Select,
        validation: getOptionValidation({ t, required: true }),
        componentProps: {
          ...selectProps,
          getLoadOptions: getSitesLoadOptions,
        },
      },
    ];
  }
  if (monitoringEntity === MonitoringEntity.Sector) {
    return [
      {
        name: MonitoringFilterFieldNames.SectorToAdd,
        label: t('choose-sector-to-add'),
        element: Select,
        validation: getOptionValidation({ t, required: true }),
        componentProps: {
          ...selectProps,
          getLoadOptions: getSectorsLoadOptions,
        },
      },
    ];
  }
  return [];
}
